import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'components/shared/ErrorPage';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Core')
class NotFoundContainer extends React.Component {
  render() {
    return (
      <NotFound {...this.props} />
    );
  }
}

class NotFound extends React.Component {
  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  render() {
    const { getString } = this.context;
    return (
      <ErrorPage errorHeading={getString('AA_Sorry')} errorText={getString('AA_NotFound')} />
    );
  }
}

export default NotFoundContainer;
